var lib_core     = require("lib-core");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");

var PackageMasterLayout = require('./templates/package__master__layout.js');

var PackageMasterView = function(model, statemachine, editorHolder, options){
    ui_extensions.MasterView.call(this, model, statemachine, editorHolder, options);
};

lib_core.inherit(PackageMasterView, ui_extensions.MasterView);

PackageMasterView.prototype.getTemplate = function(){
    if(!this._template){
        this._template = PackageMasterLayout($(this.editorHolder), this.options.noNav);
    }
    return this._template;
};

module.exports = PackageMasterView;